export const CNFlagRound = ({width = '32px', height = '32px'}) => {
    return (
        <>
            <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 32c8.837 0 16-7.163 16-15.999S24.837.002 16 .002C7.166.002.002 7.165.002 16.002c0 8.835 7.164 15.999 16 15.999Z"
                    fill="#D62427"
                />
                <path d="M0 16C0 7.163 7.163 0 16 0c8.836 0 8.836 32 0 32S0 24.836 0 16Z" fill="#DC3027" />
                <path
                    d="m9.23 4.404.746 2.3h2.417l-1.955 1.42.747 2.298-1.955-1.42-1.956 1.42.747-2.299-1.955-1.42h2.417l.747-2.299ZM14.868 3.098l-.235.806.694.473-.84.025-.235.807-.283-.791-.84.025.665-.514-.284-.79.694.473.664-.514ZM14.868 10.32l-.235.806.694.474-.84.024-.235.807-.283-.79-.84.025.665-.514-.284-.79.694.472.664-.514ZM16.915 5.299l-.235.806.694.473-.84.025-.235.807-.284-.791-.84.025.665-.514-.283-.79.694.473.664-.514ZM16.915 8.242l-.235.807.694.473-.84.024-.235.807-.284-.79-.84.025.665-.514-.283-.79.694.472.664-.514Z"
                    fill="#F8D12E"
                />
            </svg>
        </>
    );
};
